import { getLocalizedRoutes } from '@seek/melways-sites';

export const routes = [
  { name: 'priceLookup', route: '/account/ad-price-lookup' },
  { name: 'priceLookupPreview', route: '/account/ad-price-lookup/preview' },
];

export const localizeRoutesForSite = getLocalizedRoutes(routes);
